import { render, staticRenderFns } from "./SelectPathogen.vue?vue&type=template&id=3997321a&scoped=true"
import script from "./SelectPathogen.vue?vue&type=script&lang=js"
export * from "./SelectPathogen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997321a",
  null
  
)

export default component.exports